import { type Info } from '@scoring/types';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface AuthenticationState {
    infos: Info[];

    addInfo: (info: Info) => void;
    removeInfo: (info: Info) => void;
    resetInfos: () => void;
}

export const useLogStore = create<AuthenticationState>()(
    devtools(
        immer((set) => ({
            infos: [],
            addInfo: (info: Info) =>
                set((state) => {
                    state.infos.push(info);
                }),
            removeInfo: (info: Info) =>
                set((state) => {
                    state.infos = state.infos.filter((i) => i.id !== info.id);
                }),
            resetInfos: () =>
                set((state) => {
                    state.infos = [];
                }),
        }))
    )
);
